var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._b({tag:"component",on:{"value-change":_vm.handleValueChange}},'component',_vm.passedProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }